import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { RouterConstants } from '../app/Models/app-data';
import { StocktakeFormComponent } from './Components/Content/stocktake-form/stocktake-form.component';

const routes: Routes = [

    //Dashboard
    { path: RouterConstants.Stocktake, component: StocktakeFormComponent, data: { url: RouterConstants.Stocktake } },
    { path: RouterConstants.FBTDeclaration, component: StocktakeFormComponent, data: { url: RouterConstants.FBTDeclaration } },

    //Default redirection to home
    { path: RouterConstants.NoMatch, redirectTo: RouterConstants.Stocktake }
];


@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
